import { brandAssets } from '../../content/brandAssets';

/** Brand loading GIF, shown as-is while a lazy-loaded page downloads (same as the boot loader). */
export default function SiteLoader({ label = 'Loading…', size = 160 }) {
  return (
    <div className="rider-loader" role="status" aria-live="polite" aria-label={label}>
      <img src={brandAssets.loader} width={size} height={size} alt="" />
    </div>
  );
}
